export default __webpack_public_path__ + "media/react/pages/payment_flows/subscription_form/assets/powered_by_stripe-cbfd3ab8abed9f950777c18026df5568.svg";